var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBankIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 73.343,
    height: 61.499,
    viewBox: "0 0 73.343 61.499",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_60",
    "data-name": "Group 60",
    transform: "translate(-415.5 -468)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Bank_Icon",
    "data-name": "Bank Icon",
    transform: "translate(415.5 468)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_151",
    "data-name": "Path 151",
    d: "M590.617,291.341H523.1a2.914,2.914,0,0,1,0-5.828h67.515a2.914,2.914,0,0,1,0,5.828Z",
    transform: "translate(-520.188 -229.842)",
    fill: "#1d3586"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_152",
    "data-name": "Path 152",
    d: "M590.922,139.917H523.968a2.914,2.914,0,0,1-1.523-5.4l33.476-20.526a2.913,2.913,0,0,1,3.046,0l33.477,20.526a2.914,2.914,0,0,1-1.523,5.4ZM534.3,134.089h46.3L557.445,119.9Z",
    transform: "translate(-520.774 -113.563)",
    fill: "#1d3586"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_153",
    "data-name": "Path 153",
    d: "M550.272,217.408a2.914,2.914,0,0,1-2.914-2.914V181.239a2.914,2.914,0,1,1,5.828,0v33.255A2.914,2.914,0,0,1,550.272,217.408Z",
    transform: "translate(-538.561 -157.357)",
    fill: "#1d3586"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_154",
    "data-name": "Path 154",
    d: "M627.366,218.868a2.914,2.914,0,0,1-2.914-2.914V182.7a2.914,2.914,0,0,1,5.828,0v33.255A2.914,2.914,0,0,1,627.366,218.868Z",
    transform: "translate(-590.695 -158.345)",
    fill: "#1d3586"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_155",
    "data-name": "Path 155",
    d: "M704.461,220.11a2.914,2.914,0,0,1-2.914-2.914V183.941a2.914,2.914,0,0,1,5.828,0V217.2A2.914,2.914,0,0,1,704.461,220.11Z",
    transform: "translate(-642.829 -159.185)",
    fill: "#1d3586"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBankIcon);
export default __webpack_public_path__ + "static/media/bankIcon.c16e1e9f8fe46f25b548d63413258f0d.svg";
export { ForwardRef as ReactComponent };